import WrongRegionPage from "pages/WrongRegionPage/WrongRegionPage";
import { MemberState } from "lib/member";

/**
 * The page to render instead of a member's record, or null when the record may be shown.
 *
 * Every page that shows a member calls this before rendering anything of them, and it is one
 * function so that a third page cannot gate on a different set of states.
 */
export function memberReplacementPage(member: MemberState) {
  if (member.status !== "withheld") {
    return null;
  }

  return (
    <WrongRegionPage
      name={member.name}
      externalId={member.externalId}
      memberRegion={member.memberRegion}
      servingRegion={member.servingRegion}
    />
  );
}
